export const SPAIN_COUNTRY_CODE = 'es';
export const GERMANY_COUNTRY_CODE = 'de';
export const UK_COUNTRY_CODE = 'gb';
export const PORTUGAL_COUNTRY_CODE = 'pt';
export const CUSTOMERID_LENGTH = 12;
export const MAINTENANCE_UNLEASH_KEY = 'R2-MaintainceWindow';
export const ONBOARD_VIDEO_UNLEASH_KEY = 'R2-onboardingVideoLinks';
export const MENU_OPTIONS_UNLEASH_KEY = 'R2-MenuOptions';
export const ACCOUNT_SELECTION_SHOWN_KEY = 'accountSelectionShownForLogin';
export const PORTUGAL_UNLEASH_KEY = 'R2-PortugalEnabled';
export const SUPPORTED_COUNTRY_LIST = ['es', 'gb', 'de', 'pt'];
export const LANGUAGE_SUPPORTED_CODE = ['es', 'en', 'de', 'pt'];
export const SPAIN_WARRANTY_ASSET = 'powergard';
export const CURRENCY_RATE_TYPE = 'rate';
export const PAST_DUE_PAGE_SIZE = 5;
export const COUNTRY_CONTRACT_LENGTH = {
  es: 6,
  de: 7,
  gb: 8,
  pt: 6,
};
export const COUNTRY_LANGUAGE_CODE = {
  es: 'es',
  de: 'de',
  pt: 'pt',
  gb: 'en',
};
export const COUNTRY_LOCALIZATION_DETAILS = {
  es: {
    languageCode: 'es-ES',
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: true,
  },
  de: {
    languageCode: 'de-DE',
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: true,
  },
  pt: {
    languageCode: 'pt-PT',
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: true,
  },
  en: {
    languageCode: 'en-GB',
    style: 'currency',
    currency: 'GBP',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: true,
  },
};

export const NRStatus = {
  landed: 'LANDED_SECURITY_VERIFICATION',
  tnc: 'ACCEPTED_TNC',
  failed: 'FAILED',
  success: 'SUCCESSFUL',
  successStep1: 'STEP_1_SUCCESSFUL',
  successStep2: 'STEP_2_SUCCESSFUL',
  failedStep1: 'STEP_1_FAILED',
  failedStep2: 'STEP_2_FAILED',
};

export const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

export const wrapperCountryMapping = {
  EU: 'es',
  GE: 'de',
  UK: 'gb',
  PT: 'pt',
};

export const contractDetailsCardLabels = {
  'LOAN-INSTALLMENT': {
    FINANCED_AMOUNT: 'FINANCED_AMOUNT',
    CAPITAL_BALANCE: 'CAPITAL_BALANCE',
    INSTALLMENTS_DUE: 'INSTALLMENTS_DUE',
    INSTALLMENTS_PAID: 'INSTALLMENTS_PAID',
    TOOLTIP: 'TOOLTIP',
  },
  'LOAN-HIRE-PURCHASE': {
    FINANCED_AMOUNT: 'FINANCED_AMOUNT',
    CAPITAL_BALANCE: 'CAPITAL_BALANCE',
    INSTALLMENTS_DUE: 'INSTALLMENTS_DUE',
    INSTALLMENTS_PAID: 'INSTALLMENTS_PAID',
    TOOLTIP: 'TOOLTIP',
  },
  'LEASE-FINANCE': {
    FINANCED_AMOUNT: 'TOTAL_GROSS_RENTAL',
    CAPITAL_BALANCE: 'RENTAL_PAYMENT',
    INSTALLMENTS_DUE: 'PAYMENTS_DUE',
    INSTALLMENTS_PAID: 'PAYMENTS_PAID',
    TOOLTIP: 'TOOLTIP_FL',
  },
  'LEASE-OPERATING': {
    FINANCED_AMOUNT: 'TOTAL_GROSS_RENTAL',
    CAPITAL_BALANCE: 'RENTAL_PAYMENT',
    INSTALLMENTS_DUE: 'PAYMENTS_DUE',
    INSTALLMENTS_PAID: 'PAYMENTS_PAID',
    TOOLTIP: 'TOOLTIP_OL',
  },
  'LEASE-FINANCE-MUN': {
    FINANCED_AMOUNT: 'TOTAL_GROSS_RENTAL',
    CAPITAL_BALANCE: 'RENTAL_PAYMENT_FL',
    INSTALLMENTS_DUE: 'PAYMENTS_DUE',
    INSTALLMENTS_PAID: 'PAYMENTS_PAID',
    TOOLTIP: 'TOOLTIP_FL-MUN',
  },
  'LEASE-FINANCE-NON-MUN': {
    FINANCED_AMOUNT: 'TOTAL_GROSS_RENTAL',
    CAPITAL_BALANCE: 'RENTAL_PAYMENT_FL',
    INSTALLMENTS_DUE: 'PAYMENTS_DUE',
    INSTALLMENTS_PAID: 'PAYMENTS_PAID',
    TOOLTIP: 'TOOLTIP_FL-NON-MUN',
  },
};

export const Lease_types = [
  'LEASE-FINANCE',
  'LEASE-OPERATING',
  'LEASE-FINANCE-MUN',
];

export const cifRegex = /^[A-Z]\d{8}$/;
export const nifRegex = /^\d{8}[A-Z]$/;
export const nieRegex = /^[XYZ]\d{7}[A-Z]$/;
export const nifPortugalRegex = /^\d{9}$/;

export const Lease_Settlement_Quote_Allowed_List = {
  de: ['LOAN-INSTALLMENT'],
  gb: [
    'LOAN-INSTALLMENT',
    'LEASE-OPERATING',
    'LEASE-FINANCE',
    'LOAN-HIRE-PURCHASE',
  ],
  es: ['LOAN-INSTALLMENT', 'LEASE-FINANCE'],
  pt: ['LOAN-INSTALLMENT'],
};
export const Germany_Lease_Types = [
  'LEASE-OPERATING',
  'LEASE-FINANCE-MUN',
  'LEASE-FINANCE-NON-MUN',
  'LEASE-FINANCE',
];

export const idsToValidate = ['uniqueId', 'contractNumber'];

// View key (dropdown value or navigation target) -> request type name used by the API and role-access.json
export const SERVICE_REQUEST_TYPE_BY_VIEW = {
  logBookRequest: 'Log Book',
  objectChange: 'Object Change',
  partialRepayment: 'Partial early repayment',
  settlementQuote: 'Settlement quote',
  changePhone: 'Change Phone',
  changeEmail: 'Change Email',
  changeAddress: 'Change Address',
  createBankMandate: 'Bank Mandate',
  authorizedUserManage: 'Modification in Authorised Signatory',
  manageDelegate: 'Manage Delegate',
  raiseComplaint: 'Raise a Complaint',
  download: 'Download Document',
};
